import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

/**
 * 首页api
 */
import CommonApi from 'api/common.js';

var api = _defineProperty({
  carouselList: function carouselList() {
    return CommonApi.post('/dayaotex-server-admin/carouselApp/carouselList');
  },

  /**
   * 文章内容列表
   */
  newsBody: function newsBody() {
    return CommonApi.post('/dayaotex-server-admin/body/newsBody');
  },
  // 爆款大类
  selectRelationTemplateExplosions: function selectRelationTemplateExplosions() {
    return CommonApi.post('/dayaotex-server-goods/goodsTemplate/selectRelationTemplateExplosions');
  },
  // 推荐大类
  selectRelationTemplateRecommend: function selectRelationTemplateRecommend() {
    return CommonApi.post('/dayaotex-server-goods/goodsTemplate/selectRelationTemplateRecommend');
  },
  // 首页大类
  showAppButtonList: function showAppButtonList() {
    return CommonApi.post('/dayaotex-server-admin/appButton/showAppButtonList');
  },
  // 首页产业链服务
  selectIndustryChainList: function selectIndustryChainList() {
    return CommonApi.post('/dayaotex-server-admin/industryChain/industryChainList');
  },
  //资质列表
  selectCertificationList: function selectCertificationList(data) {
    return CommonApi.post('/dayaotex-server-goods/certification/selectCertificationList', data);
  },
  //资质详情
  selectCertificationInfo: function selectCertificationInfo(data) {
    return CommonApi.post('dayaotex-server-goods/certification/selectCertificationInfo', data);
  },
  //服务列表
  selectServeList: function selectServeList(data) {
    return CommonApi.post('/dayaotex-server-goods/dayaoFuWu/selectCertificationList', data);
  },
  //服务详情
  selectServeInfo: function selectServeInfo(data) {
    return CommonApi.post('dayaotex-server-goods/dayaoFuWu/selectCertificationInfo', data);
  },
  selectAppRecommendList2: function selectAppRecommendList2(data) {
    return CommonApi.post('/dayaotex-server-goods/recommend/selectAppRecommendList2', data);
  }
}, "selectIndustryChainList", function selectIndustryChainList() {
  return CommonApi.post('/dayaotex-server-admin/industryChain/industryChainList');
});

export default api;